<template>
  <div class="history_home">
    <common-header></common-header>
    <time-nav @changeYear="changeYear"></time-nav>
    <div class="work_wrap" v-if="workData.video.length">
      <img src="../../img/vlog_head.png" alt="" class="work_title" style="width: 2.82rem">
      <div class="work_con clearfix">
        <img src="../../img/triangle.png" alt="" class="triangle">
        <div class="clearfix" v-if="workData.video.length">
          <div class="first_work" @click="goDetail(workData.video[0])">
            <img :src="'https://collection2021-cos.chineseplus.net/'+workData.video[0].video_cover" alt="">
          </div>
          <ul class="work_list">
            <li v-for="(v, i) in workData.video.slice(1)" :key="i" @click="goDetail(v)">
              <img :src="'https://collection2021-cos.chineseplus.net/'+v.video_cover" alt="">
            </li>
          </ul>
        </div>
        <div class="more" @click="goList(1)">
          查看更多
        </div>
      </div>
    </div>

     <div class="work_wrap">
      <img src="../../img/plog_head.png" alt="" class="work_title" style="width: 2.04rem">
      <div class="work_con clearfix">
        <img src="../../img/triangle.png" alt="" class="triangle">
        <div class="clearfix"  v-if="workData.photo.length">
          <div class="first_work" @click="goDetail(workData.photo[0])">
            <img :src="'https://collection2021-cos.chineseplus.net/'+workData.photo[0].cover" alt="">
          </div>
          <ul class="work_list">
            <li v-for="(v, i) in workData.photo.slice(1)" :key="i" @click="goDetail(v)">
              <img :src="'https://collection2021-cos.chineseplus.net/'+v.cover" alt="">
            </li>
          </ul>
        </div>
        <div class="more" @click="goList(2)">
          查看更多
        </div>
      </div>
    </div>

    <div class="work_wrap">
      <img src="../../img/single_head.png" alt="" class="work_title" style="width: 2.04rem">
      <div class="work_con clearfix">
        <img src="../../img/triangle.png" alt="" class="triangle">
        <div class="clearfix" v-if="workData.single.length">
          <div class="first_work" @click="goDetail(workData.single[0])">
            <img :src="'https://collection2021-cos.chineseplus.net/'+workData.single[0].cover" alt="">
          </div>
          <ul class="work_list">
            <li v-for="(v, i) in workData.single.slice(1)" :key="i" @click="goDetail(v)">
              <img :src="'https://collection2021-cos.chineseplus.net/'+v.cover" alt="">
            </li>
          </ul>
        </div>
        <div class="more" @click="goList(3)">
          查看更多
        </div>
      </div>
    </div>

    <common-footer></common-footer>
  </div>
</template>

<script>
import timeNav from './common/timeNav'
import commonHeader from '../common/commonHeader2'
import commonFooter from '../common/commonFooter'

export default {
  components: {
    timeNav,
    commonHeader,
    commonFooter
  },
  data () {
    return {
      type: 1,
      yearList: [
        {
          value: '2015年'
        },
        {
          value: '2016年'
        },
        {
          value: '2017年'
        },
        {
          value: '2018年'
        },
        {
          value: '现在'
        }
      ],
      yearIndex: 0,
      workData: {
        video: [],
        photo: [],
        single: []
      }
    }
  },
  created () {
    this.changeYear(this.$route.query.year || 0)
  },
  methods: {
    changeYear (yearIndex) {
      this.yearIndex = yearIndex
      this.$router.push({
        path: this.$route.path,
        query: {
          year: yearIndex
        }
      })
      this.getList()
    },
    goList (type) {
      this.type = type
      this.$router.push({
        path: '/mpage/m_history_list',
        query: {
          type,
          year: this.yearIndex
        }
      })
    },
    // 获取列表
    getList () {
      this.$utils.get('/works/history/index', {
        year: this.yearList[this.yearIndex].value.substr(0, 4)
      }).then(res => {
        if(res.code == 1000) {
          this.workData = res.data
        }
      })
    },
    // 去详情
    goDetail (item) {
      let path = ''
      if (item.type == 1) {
        path = '/mpage/m_history_videoworksInfo'
      } else {
        path = '/mpage/m_history_picworksInfo'
      }
      this.$router.push({
        path,
        query: {
          id: item.works_id
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.history_home {
  width: 100%;
  height: 100%;
  margin: auto;
  font-size: .3rem;
  .nav_con {
    color: #fff;
    font-size: .3rem;
    margin-top: 30px;
    .home_tab {
      cursor: pointer;
    }
  }
  .work_wrap {
    margin-bottom: .6rem;
    width: calc(100% - .9rem);
    margin: auto;
    margin-bottom: .6rem;
    .work_title {
      display: block;
      margin: auto;
      margin-bottom: .76rem;
    }
    .work_con {
      background: rgba(255, 255, 255, .8);
      position: relative;
      padding: .4rem;
      .triangle {
        width: .96rem;
        position: absolute;
        top: -.48rem;
        left: 50%;
        margin-left: -.48rem;
      }
      .first_work {
        width: 100%;
	      height: 7.15rem;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .work_list {
        float: right;
        width: 100%;
        li {
          float: left;
          margin-right: .25rem;
          margin-top: .25rem;
          width: calc((100% - .25rem) / 2);
          height: 3.45rem;
          cursor: pointer;
          &:nth-child(2n) {
            margin-right: 0;
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
      .more {
        font-size: .3rem;
        color: #fff;
        text-align: center;
        width: 2.5rem;
	      padding: .18rem 0;
        background-color: #458beb;
	      border-radius: .3rem;
        margin: auto;
        margin-top: .4rem;
        cursor: pointer;
      }
    }
  }
}
</style>
